module.exports = __webpack_public_path__ + "img/levelup-icon-x-deny.aa073339.svg";